import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },

  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },

  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },

  infoContainer: {
    display: 'flex',
    marginBottom: theme.spacing(4),
    height: '25%',
  },
}));
